// 예·적금 세전 이자와 이자소득세(15.4%) 계산. 복리는 월복리 기준입니다.
export const TAX_RATE = 0.154;

export function interest({ kind = 'deposit', amount = 0, rate = 0, months = 12, method = 'simple' }) {
  const r = Number(rate) / 100 / 12;
  const m = Math.max(0, Math.round(Number(months)));
  const a = Math.max(0, Number(amount));
  if (!Number.isFinite(r) || !Number.isFinite(a) || !m) return NaN;
  if (kind === 'deposit') return method === 'compound' ? a * ((1 + r) ** m - 1) : a * r * m;
  // 적금: 매월 초 같은 금액을 넣는다고 가정합니다. k개월 동안 예치되는 납입분의 이자를 모두 더합니다.
  if (method === 'compound') { let total = 0; for (let k = 1; k <= m; k++) total += a * ((1 + r) ** k - 1); return total; }
  return a * r * (m * (m + 1)) / 2;
}

export function estimate(input) {
  const gross = interest(input);
  const tax = Math.floor((gross * TAX_RATE) / 10) * 10;
  const principal = input.kind === 'deposit' ? Number(input.amount) : Number(input.amount) * Math.round(Number(input.months));
  return { gross, tax, net: gross - tax, principal, total: principal + gross - tax };
}

export const won = n => (Number.isFinite(n) ? Math.max(0, Math.round(n)).toLocaleString('ko-KR') : '—');
export const pct = n => (n == null || !Number.isFinite(Number(n)) ? '—' : `${Number(n).toFixed(2)}%`);
export const methodOf = p => (p?.method === '복리' ? 'compound' : 'simple');
